
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from '@/mixins';

@Component
export default class TopNavigationBar extends Mixins(VuetifyMixin){
	@Prop({type: Boolean}) loading;
	@Prop({type: Boolean}) showBack;
	@Prop({type: Boolean}) showText;
	@Prop({type: Boolean}) showAction;
	@Prop({type: String}) backText;
	@Prop({type: String}) backTooltip;
	@Prop({default: 'mdi-chevron-left'}) backIcon: string;
	@Prop({type: String}) actionText;
	@Prop({type: String}) actionTooltip;
	@Prop({type: String}) actionColor;
	@Prop({default: 'mdi-forward'}) actionIcon: string;

	get ActionColor(): string {
		if(!this.actionColor) return "primary lighten-1"
		return this.actionColor;
	}
}
